module.exports = __webpack_public_path__ + "img/image 6.02c4d82c.png";